const step_up = {
    verify_your_identity: 'Verify your identity',
    choose_method_description: 'To continue, confirm it’s you with one of the following methods.',
    password: 'Password',
    password_description: 'Enter your account password',
    enter_password_description: 'Enter your account password to continue.',
    enter_verification_code_description: 'Enter the verification code sent to {{identifier}}.',
    subject_proof_description: 'To continue, confirm it’s you through an account linked to yours. You can then set up a verification method.',
    subject_mismatch: 'Account doesn’t match',
    subject_mismatch_description: 'The account you used isn’t linked to your account. Use a linked account, and switch accounts at the provider if needed.',
    no_method_available: 'No verification method available',
    no_method_available_description: 'Your account has no method that can complete this verification. Please contact your administrator for assistance.',
};
export default Object.freeze(step_up);
